




















































/// <reference types="@venkatperi/vue-shims"/>

import { Component, Lifecycle, p, Prop, Watch } from "av-ts";
import Vue from 'vue'
import resize from 'vue-resize-directive'
import BaseComponent from "../BaseComponent";
import Handle from './Handle.vue'
import Pane from './Pane.vue'

const debounce = require('lodash.debounce')

@Component({
    name: 'VueSplitter',
    components: {Handle, Pane},
    directives: {resize},
    props: {
        minSize: {
            type: [String, Number],
            default: '20%'
        },
        maxSize: {
            type: [String, Number],
            default: '80%'
        },
        initialSize: {
            type: [String, Number],
            default: '50%'
        },
    }
})
export default class Container extends BaseComponent {

    dragging: boolean = false

    hasMoved: boolean = false

    currentSize: string | number = '50%'

    sizes = [[0, 0], [0, 0]]

    handler: (e: MouseEvent) => void = this.doResize.bind(this)

    $refs!: {
        one: Vue,
        two: Vue,
    }

    minSize!: string | number

    maxSize!: string | number

    initialSize!: string | number

    @Prop throttle = p({
        type: Number,
        default: -1
    })

    @Prop handleSize = p({
        type: Number,
        default: 9
    })


    @Watch('sizes')
    sizesChanged() {
        this.$emit('resize', this.sizes[0], this.sizes[1])
    }

    @Watch('currentSize')
    currentSizeChanged() {
        this.updateSizes()
    }

    @Watch('initialSize')
    initialSizeChanged() {
        this.currentSize = this.initialSize
    }

    @Watch('throttle')
    onThrottleChanged() {
        this.updateHandler()
    }

    @Lifecycle
    created() {
        this.currentSize = this.initialSize
        this.updateHandler()
    }

    @Lifecycle
    mounted() {
        this.updateSizes()
    }

    get paneOneStyles(): any {
        let s = {
            [this.type]: this.currentSize
        }
        if (this.minSize) {
            s[`min-${this.type}`] = this.minSize
        }
        if (this.maxSize) {
            s[`max-${this.type}`] = this.maxSize
        }
        return s
    }

    get type(): string {
        return this.split === 'vertical' ? 'width' : 'height'
    }

    get positionOne(): string {
        return this.split === 'vertical' ? 'left' : 'top'
    }

    get positionTwo(): string {
        return this.split === 'vertical' ? 'right' : 'bottom'
    }

    get isVertical(): boolean {
        return this.split === 'vertical'
    }

    updateHandler() {
        let self = this
        this.handler =
            this.throttle < 0
            ? this.doResize.bind(this) :
            debounce((e: MouseEvent) => self.doResize(e),
                this.throttle, {
                    leading: true,
                    trailing: true,
                    maxWait: this.throttle
                })
    }

    updateSizes() {
        let one = this.$refs.one.$el
        let two = this.$refs.two.$el
        this.sizes = [
            [one.clientWidth, one.clientHeight],
            [two.clientWidth, two.clientHeight]]

        if (this.forceSizing) {
            this.$refs.one.$emit('resize')
            this.$refs.two.$emit('resize')
        }
    }

    onDblClick() {
        if (!this.hasMoved) {
            this.currentSize = this.initialSize
        }
    }

    onMouseDown() {
        this.dragging = true
        this.hasMoved = false
    }

    onMouseUp() {
        this.dragging = false
    }

    onMouseMove(e: MouseEvent) {
        this.handler(e)
    }

    doResize(e: MouseEvent) {
        if (e.buttons === 0) {
            this.dragging = false
        }

        if (this.dragging && e.currentTarget &&
            e.currentTarget instanceof HTMLElement) {
            let t: HTMLElement = e.currentTarget
            let r = t.getBoundingClientRect()

            const [currentPage, targetOffset, offset] =
                this.isVertical
                ? [e.pageX, t.offsetWidth, window.pageXOffset + r.left]
                : [e.pageY, t.offsetHeight, window.pageYOffset + r.top]

            let diff = currentPage - offset
            this.currentSize = `${(diff / targetOffset) * 100}%`

            this.hasMoved = true
        }
    }

}
